import ApiService from './_api.service'
import { Branch as Model } from '@/models/branch.model'

const BranchService = {
    create: function(entity) {
        let data = new FormData()
        Object.keys(Model.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.post(process.env.VUE_APP_API_BRANCHES_URL, data)
    },

    createRelationship: function(branch_id, dc_id, node_id) {
        let data = new FormData()
        data.set('child_branch', branch_id)
        data.set('parent_branch', dc_id)
        data.set('node', node_id)

        return ApiService.post(
            process.env.VUE_APP_API_BRANCHES_URL + 'relationships/',
            data
        )
    },

    read: function(args) {
        let queryParams = '?'
        if (args) {
            if (typeof args == 'number') queryParams = args + '/'
            else
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
        }
        return ApiService.get(
            process.env.VUE_APP_API_BRANCHES_URL + queryParams
        )
    },
    readUrl: function(url) {
        if (!url) return

        return ApiService.get(url)
    },
    readChannels: async function() {
        let channels = (
            await ApiService.get(
                process.env.VUE_APP_API_BRANCHES_URL + 'channels/'
            )
        ).data

        // transform {id: name} to [{'id':id, 'name': name}]
        let channelsFormatted = []
        Object.keys(channels).forEach(key => {
            // translate name if recognized
            let name = channels[key]
            if (name == 'Retail') name = 'Varejo'
            else if (name == 'Wholesale') name = 'Atacado'
            channelsFormatted.push({
                id: key,
                name: name
            })
        })
        return channelsFormatted
    },
    readDcs: async function(args) {
        let queryParams = '?'
        if (args !== undefined) {
            if (Object.keys(args).length !== 0) {
                Object.keys(args).forEach(key => {
                    if (args[key] != null && args[key] != '')
                        queryParams += key + '=' + args[key] + '&'
                })
            }
        }

        return await ApiService.get(
            process.env.VUE_APP_API_BRANCHES_URL + 'dcs/' + queryParams
        )
    },
    readProducts: async function() {
        return await ApiService.get(
            process.env.VUE_APP_API_BRANCHES_URL + 'products/'
        )
    },
    readBranches: async function() {
        return await ApiService.get(
            process.env.VUE_APP_API_BRANCHES_URL + 'branches/'
        )
    },
    readById: async function(id) {
        if (!id) return
        return await ApiService.get(process.env.VUE_APP_API_BRANCHES_URL + id)
    },
    readNameIds: args => {
        let queryParams = '?'
        if (args)
            Object.keys(args).forEach(key =>
                args[key] ? (queryParams += key + '=' + args[key] + '&') : ''
            )

        return ApiService.get(
            process.env.VUE_APP_API_BRANCHES_URL + 'nameids/' + queryParams
        )
    },

    update: async function(id, entity) {
        let data = new FormData()
        Object.keys(Model.editableFields).forEach(field => {
            if (entity[field] != null) data.set(field, entity[field])
        })
        return ApiService.patch(
            process.env.VUE_APP_API_BRANCHES_URL + id + '/',
            data
        )
    },

    delete: async function(id) {
        return ApiService.delete(
            process.env.VUE_APP_API_BRANCHES_URL + id + '/'
        )
    },
    deleteRelationship: async function(id) {
        return ApiService.delete(
            process.env.VUE_APP_API_BRANCHES_URL + 'relationships/' + id + '/'
        )
    },

    readDcNamesById: async function(id) {
        if (!id) return
        return ApiService.get(
            process.env.VUE_APP_API_BRANCHES_URL + id + '/dc-names/'
        )
    },

    readRelationships: async function(args) {
        let queryParams = '?'
        if (args)
            Object.keys(args).forEach(key =>
                args[key] ? (queryParams += key + '=' + args[key] + '&') : ''
            )

        return ApiService.get(
            process.env.VUE_APP_API_BRANCHES_URL +
                'relationships/' +
                queryParams
        )
    },

    saveRelationships: async function(relationships) {
        let data = new FormData()
        data.set('relationships', JSON.stringify(relationships))

        return ApiService.post(
            process.env.VUE_APP_API_BRANCHES_URL + 'relationships/save_many/',
            data
        )
    }
}

export default BranchService
export { BranchService }
